import {baseAxios} from '../helper/axiosHelper';

export const dashboarddataService = {
    getLastChangedOffers,
    getLastChangedOrders,
    getLastChangedContacts,
    getChartData2YearIncome,
    getLastChangedPartnerOrder
};

function getLastChangedOffers() {

    return baseAxios.get('dashboarddata/lastchangedoffer')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getLastChangedPartnerOrder() {

    return baseAxios.get('dashboarddata/lastchangedpartnerorder')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getLastChangedContacts() {

    return baseAxios.get('dashboarddata/lastchangedcontact')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getLastChangedOrders() {

    return baseAxios.get('dashboarddata/lastchangedorder')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getChartData2YearIncome() {

    return baseAxios.get('dashboarddata/chartdata/twoyearincome')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}